import { createFileRoute, useNavigate } from '@tanstack/react-router';
import LoadingIndicator from 'react-loading-indicator';
import { InvalidResponseCode } from 'tg-resources';
import PerfusionDeviceForm from '../../../../Components/PerfusionDeviceForm';
import { useCanViewPerfusionDevices } from '../../../../Hooks/featurePermission';
import { usePerfusionDevice } from '../../../../Hooks/perfusionDevice';
import PerfusionDeviceMessages from '../../../../Lang/perfusion-device';
import { deviceRouteSchema } from '../../../../Utils/routeSchema';
import { useFeaturePermissions } from '../../../../Selectors/Permission';

export const Route = createFileRoute('/(main)/_layout/devices/$deviceId/edit')({
  params: {
    parse: (params) => deviceRouteSchema.parse(params),
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { deviceId } = Route.useParams();
  const navigate = useNavigate();
  const canViewPerfusionDevices = useCanViewPerfusionDevices();
  const featurePermissions = useFeaturePermissions();
  const {
    data: device,
    isLoading,
    error,
  } = usePerfusionDevice(deviceId, {
    enabled: canViewPerfusionDevices,
  });
  const goToDevices = () => navigate({ to: '/devices' });

  if (!canViewPerfusionDevices) {
    return (
      <div className="perfusion-devices-page perfusion-devices-message">
        {featurePermissions.perfusionDevices
          ? PerfusionDeviceMessages.noListAccess
          : PerfusionDeviceMessages.featureDisabled}
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="perfusion-devices-page perfusion-devices-loading">
        <LoadingIndicator />
      </div>
    );
  }

  if (!device) {
    return (
      <div className="perfusion-devices-page perfusion-devices-message">
        {error instanceof InvalidResponseCode && error.statusCode === 403
          ? PerfusionDeviceMessages.noPermission('edit')
          : PerfusionDeviceMessages.deviceUnavailable}
      </div>
    );
  }

  if (!device.rights.update) {
    return (
      <div className="perfusion-devices-page perfusion-devices-message">
        {PerfusionDeviceMessages.noPermission('edit')}
      </div>
    );
  }

  // Keyed so the form starts over if a different device is opened in place
  return <PerfusionDeviceForm key={device.deviceId} device={device} onClose={goToDevices} onSaved={goToDevices} />;
}
